import React from 'react';
import Button from 'react-bootstrap/Button';
import { useSelector, useDispatch } from 'react-redux';
import { selectActiveTab } from 'shared/product_tabs/tabs/selector';
import { TAB_FABRICATION, TAB_ASSEMBLY } from 'shared/product_tabs/tabs/tabType';
import { changeTab } from 'shared/product_tabs/tabs/tabSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ContinueButton = () => {
  const activeTab = useSelector(selectActiveTab);
  const dispatch = useDispatch();

  const nextTab = () => {
    if (activeTab === TAB_FABRICATION) {
      return TAB_ASSEMBLY;
    }
    return null;
  };

  const nextTabName = () => {
    if (nextTab() === TAB_ASSEMBLY) {
      return 'Assembly';
    }
    return '';
  };

  const onContinue = () => {
    const tab = nextTab();

    if (tab) {
      dispatch(changeTab(tab));
    }
  };

  return (
    <Button variant="outline-primary" onClick={onContinue} className="continue-button font-weight-bold">
      Continue to {nextTabName()}
      <FontAwesomeIcon icon={['fas', 'arrow-right']} className="ml-1" />
    </Button>
  );
};

export default ContinueButton;